import * as yup from "yup"
import { useAppLocalization } from "../../../../../localization/components/AppLocalizationProvider"

export const useMerchantOpeningHoursValidationScheme = () => {
    const { l10n } = useAppLocalization()

    const createDayValidationSchema = () =>
        yup.object().shape({
            isOpen: yup.boolean(),
            open: yup
                .date()
                .nullable()
                .when("isOpen", {
                    is: true,
                    then: (schema) =>
                        schema.typeError(l10n.getString("required-field")).required(l10n.getString("required-field")),
                    otherwise: (schema) => schema.nullable(),
                }),
            close: yup
                .date()
                .nullable()
                .when("isOpen", {
                    is: true,
                    then: (schema) =>
                        schema
                            .typeError(l10n.getString("required-field"))
                            .required(l10n.getString("required-field"))
                            .min(
                                yup.ref("open"),
                                l10n.getString("merchant-update-account-opening-hours-dialog-before-start-error"),
                            ),
                    otherwise: (schema) => schema.nullable(),
                }),
        })

    return yup.object().shape({
        monday: createDayValidationSchema(),
        tuesday: createDayValidationSchema(),
        wednesday: createDayValidationSchema(),
        thursday: createDayValidationSchema(),
        friday: createDayValidationSchema(),
        saturday: createDayValidationSchema(),
        sunday: createDayValidationSchema(),
    })
}
